import { TFunction } from 'i18next'
import z from 'zod'

import { AutomaticPaymentRemindersType } from '../enums/automaticPaymentRemindersType'
import { PaymentReminderDetailsRepeatType } from '../enums/paymentReminderDetailsRepeatType'
import { PaymentRemindersDetails } from '../types/paymentReminders/paymentRemindersDetails'
import { getNDaysSchema } from './getNDaysSchema'

export const getAutomaticPaymentRemindersDetailsSchema = (
  t: TFunction,
  variant: AutomaticPaymentRemindersType,
): z.ZodType<PaymentRemindersDetails> => {
  // Fields present in all variants
  const baseDetailsFields = {
    active: z.boolean(),
    emailBody: z.string().nonempty({
      message: t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.error.email_body'),
    }),
    emailSubject: z.string().nonempty({
      message: t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.error.email_subject'),
    }),
  }

  // Variant-specific fields
  const hasRepeatField = variant === AutomaticPaymentRemindersType.AfterDueDate
  const hasNDaysField = variant !== AutomaticPaymentRemindersType.OnDueDate

  return z.object({
    ...baseDetailsFields,
    ...(hasNDaysField && { nDays: getNDaysSchema(t) }),
    ...(hasRepeatField && { repeat: z.nativeEnum(PaymentReminderDetailsRepeatType) }),
  }) as z.ZodType<PaymentRemindersDetails>
}
